import {
  Box,
  Button,
  CustomerListItem,
  CustomerListItemButton,
  ErrorListItem,
  ListContentIsland,
} from '@razz-team/ui-web';
import { useAvailableBusinesses } from '../../../api/businesses';
import { AuthLayout } from '../AuthPage/AuthLayout';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { Route } from '../../../routes/switch';
import { useSwitchBusinessMutation } from '../../../api/auth';

export function SwitchPage() {
  const { t } = useTranslation();
  const availableQuery = useAvailableBusinesses();
  const navigate = Route.useNavigate();

  const switchMutation = useSwitchBusinessMutation();

  useEffect(() => {
    if (switchMutation.isSuccess) {
      navigate({ to: '/account/home', replace: true });
    }
  }, [switchMutation.isSuccess, navigate]);

  return (
    <AuthLayout>
      <Box
        width="100%"
        height="100%"
        display="flex"
        alignSelf="center"
        justifySelf="center"
        alignItems="center"
        justifyContent="center"
      >
        <ListContentIsland
          title={t('Select business account')}
          sx={{ width: '100%', maxWidth: 400 }}
          actions={
            <Button href="/new-business" variant="text">
              {t('Create new')}
            </Button>
          }
        >
          {availableQuery.isPending ? (
            <CustomerListItem loading />
          ) : availableQuery.isError ? (
            <ErrorListItem error={availableQuery.error} />
          ) : (
            availableQuery.data?.map(({ profile }) => (
              <CustomerListItemButton
                key={profile.id}
                customer={profile}
                onClick={() => switchMutation.mutate(profile.id)}
              />
            ))
          )}
        </ListContentIsland>
      </Box>
    </AuthLayout>
  );
}
